module.exports = __webpack_public_path__ + "media/svg-new/icon-trash-1cbe10dc.svg";